//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from "../../api/common";
export default {
    data() {
        return {
            doctorid: '',//医生id
            patientid: '',//患者id
            hospitaid: this.$route.query.hospitaid,//机构id
            doctor: {},//医生信息
            hospitaname: this.$route.query.hospitaname,
            presentmonth: [],//当前月信息
            nextmonth: [],//下个月信息
            month: '',
            monthArr: ['','一','二','三','四','五','六','七','八','九','十','十一','十二'],
            weekArr: ['','日','一','二','三','四','五','六'],
        }
    
    },
    methods: {
        //获取当前医生值班信息
        getDutyInfo(){
            let params = {
                parameters: this.doctorid,//医生id
                parametersone: this.patientid,//患者id
                twoParameter: this.hospitaid//机构id
            };
            this.$doRequest("api/doctorvisit/getdoctorid", params, res=>{
                this.doctor = res.doctor;
                res.doctorvisit.benyue.forEach(item => {
                    item.visittime = common.timestampToTime(item.visittime,2);
                    item.whatday = this.weekArr[item.whatday];
                    if(item.day === 0){
                        item.day = '今天';
                    }else if(item.day == 1){
                        item.day = '明天';
                    }else{
                        item.day = item.day+'天后';
                    }
                });
                this.presentmonth = res.doctorvisit.benyue;
                res.doctorvisit.xiayue.forEach(item => {
                    item.visittime = common.timestampToTime(item.visittime,2);
                    item.whatday = this.weekArr[item.whatday];
                    if(item.day == 0){
                        item.day = '今天';
                    }else if(item.day == 1){
                        item.day = '明天';
                    }else{
                        item.day = item.day+'天后';
                    }
                });
                this.nextmonth = res.doctorvisit.xiayue;
            });
        },
        //获取当前月
        getMonth(){
            var date = new Date;
            this.month = this.monthArr[date.getMonth()+2];
        },
        //去挂号支付
        goMakePay(row){
            this.$router.push({ path: "/orgMakeRegisterPay", query: {dutyid: row.id, headphoto: this.doctor.headphoto ,hospitaname: this.doctor.hospitaname}});
        },
        init(){
            this.doctorid = this.$store.state.AllOfValue.doctorId || '00a7bab1c5f241a999542eb0f6d50b61';
            this.patientid = this.$store.state.userInfo.id;
            this.getDutyInfo();
            this.getMonth();
        }
    },
    //生命周期之创建完成
    created: function() {
        document.title = '预约挂号';
        this.$isLogin(window.location.search.substr(1), this.init);
    }
}



// WEBPACK FOOTER //
// ./src/views/orgMakeRegister/index.vue